const getRawPrice = (price) => {
  const nonDigitsRegex = /[^0-9.]/g;

  return price.replace(nonDigitsRegex, '');
};

const getRawPriceWithDiscount = (price, discount) => {
  const percentage = 100 - discount;
  return (price * percentage * 0.01).toFixed(2);
};

const getFormatPrice = (price) => {
  const arr = price.toString().split('').reverse();
  let result = '';

  arr.forEach((item, index) => {
    if (!(index % 3) && !result.startsWith('.')) {
      result = ` ${result}`;
    }

    result = item + result;
  });

  result += ' ₽';
  return result;
};

const addDiscountClass = (el) => {
  if (el) el.classList.add('_with_discount');
};

const showPriceBlock = (el) => {
  if (el) el.classList.remove('hidden');
};

const getDiscount = async () => {
  try {
    const rawResponse = await fetch('/api/loyalty/user/discount/');
    const response = await rawResponse.json();

    const { data: { discount } } = response;

    return discount;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);

    return 0;
  }
};

const init = async () => {
  const discount = await getDiscount();
  const productCards = document.querySelectorAll('.product-card');

  if (discount) {
    productCards.forEach((el) => {
      const priceBlock = el.querySelector('.product-card__price');
      const fullPriceBlock = priceBlock.querySelector('.product-card__price--full');
      const discountPriceBlock = priceBlock.querySelector('.product-card__price--discount');

      const rawPrice = getRawPrice(fullPriceBlock.innerHTML);
      const rawPriceWithDiscount = getRawPriceWithDiscount(rawPrice, discount);
      const priceWithDiscount = getFormatPrice(rawPriceWithDiscount);
      if (priceWithDiscount) {
        discountPriceBlock.innerText = priceWithDiscount;
        addDiscountClass(priceBlock);
      }
      showPriceBlock(priceBlock);
    });
  } else {
    productCards.forEach((el) => {
      const priceBlock = el.querySelector('.product-card__price');
      showPriceBlock(priceBlock);
    });
  }
};

init();

window.loyaltyProgramInit = init;
